import { render, staticRenderFns } from "./BenefitRequestProcess.vue?vue&type=template&id=1ed6df65"
import script from "./BenefitRequestProcess.vue?vue&type=script&lang=js"
export * from "./BenefitRequestProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports